export default "__VITE_ASSET__BTQw0yq3__"